import { Typography } from '@mui/material';

interface ErrorMsgPropsType {
  error: string,
  customStyle?
}
const ErrorMsg = ({ error, customStyle }: ErrorMsgPropsType) => {
  return (
    <Typography sx={{ fontWeight: 'bold', color: 'red', fontSize: '13px', ...customStyle }}>
      {error}
    </Typography>
  );
};

export default ErrorMsg;
